import { Button } from "@dropbox/dig-components/buttons";
import { Modal } from "@dropbox/dig-components/modal";
import { Text } from "@dropbox/dig-components/typography";
import i18n from "@mirage/translations";
import { useEffect, useRef } from "react";

const RETRY_TIMEOUT = 10000;

export const NetworkErrorModal: React.FC<{
  retry: () => void | Promise<void>;
  secondaryButtonText?: string;
  onSecondaryButtonClick?: () => void;
}> = ({ retry, secondaryButtonText, onSecondaryButtonClick }) => {
  const isRetryingRef = useRef(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const tryRetry = async () => {
      if (isRetryingRef.current) return;
      isRetryingRef.current = true;
      try {
        await Promise.resolve(retry());
      } finally {
        isRetryingRef.current = false;
        timerRef.current = setTimeout(tryRetry, RETRY_TIMEOUT);
      }
    };
    timerRef.current = setTimeout(tryRetry, RETRY_TIMEOUT);
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [retry]);

  const renderSecondaryButton = () => {
    if (!secondaryButtonText || !onSecondaryButtonClick) return null;
    return (
      <Button variant="outline" onClick={onSecondaryButtonClick}>
        {secondaryButtonText}
      </Button>
    );
  };

  return (
    <Modal open={true}>
      <Modal.Header hasBottomSpacing="title-small">
        <Modal.Title>{i18n.t("network_error_title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Text>{i18n.t("network_error_message")}</Text>
      </Modal.Body>
      <Modal.Footer>
        {renderSecondaryButton()}
        <Button variant="primary" onClick={retry}>
          {i18n.t("logging_in_try_again")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
